<div class="model-accuracy-content-container">
  <div class="container">

    <div class="left-column">

      <app-notification-popup 
      [isVisible]="isNotificationPopupOpen"
      (close)="closeNotificationPopup()"
      [errorMessage]="errorMessage()"
      [secondErrorMessage]="secondErrorMessage()"
      ></app-notification-popup>
      
      <div class="run-date-container">

        <div class="test-period-container">
          <span class="setup-text">Set test period:</span>
          <div class="date-picker-container">
            <p-datepicker 
            [(ngModel)]="predictionRange" 
            appendTo="body"
            selectionMode="range" 
            dateFormat="mm/dd/yy" 
            placeholder="Select run range" 
            (onSelect)="onRunRangeChange($event)"
            [showIcon]="true"
            [readonlyInput]="true" />
          </div>
        </div>
  
        <app-loading-button
        [label]="'Run backtest'"
        [isLoading]="isSpinnerVissible()"
        [isDisabled]="isRunButtonDisabled()"
        (clicked)="getModelAccuracyData()"
        [customClass]="'model-accuracy-run-button'"
        ></app-loading-button>
        <!-- <button 
        [disabled]="isRunButtonDisabled()"
        [ngClass]="isRunButtonDisabled() ? 'inactive-button' : 'active-button'"
        class="run-button run-strategy-button" (click)="getModelAccuracyData()">Run Backtest</button>       -->
        <!-- <hr class="divider"> -->
        
      </div>

      <p-divider></p-divider>

      <div class="period-exclusion-container">
        <div class="text-and-calendar">
          <div><span class="setup-text">Set up to 5 periods to exclude for the current run.</span></div>
          <div class="date-picker-container">
            <p-datepicker 
            [(ngModel)]="rangeDates" 
            appendTo="body"
            selectionMode="range" 
            dateFormat="mm/dd/yy" 
            placeholder="Select date range" 
            (onSelect)="onDateRangeChange($event)"
            [showIcon]="true"
            [readonlyInput]="true" />
          </div>

        </div>

        <div class="card card-full-height excluded-ranges-list">
           <div class="excluded-items-container">
              <div class="excluded-item" *ngFor="let range of exclusionDateRanges; let i = index">
                {{ formatRange(range.start, range.end) }}
                <fa-icon [icon]="faXmark"  (click)="removeRange(i)"></fa-icon> 
              </div>
           </div>
         
        </div>

      </div>
      
    </div>
    <p-divider layout="vertical"></p-divider>
    <div class="right-column" *ngIf="isVisible">
      <div class="left-side">
            <app-results-table class="model-accuracy-table"
              [columnsResults]="columnsAllTrades" 
              [rowsResults]="rowsAllTrades"
              [rowsPerPage]="7"
              [usePagination]="true"></app-results-table>
          <div class="text-button-container">
            <button 
            class="reset-chart-button"
            (click)="reset()">Reset table</button>
          </div>
          
      </div>
      <div class="card card-histogram">
        <div class="card-content">
          <app-histograma class="histogram" dataKey="modelAccuracy"></app-histograma>
        </div>
      </div>
      
    </div>

  </div>
</div>